module.exports = __webpack_public_path__ + "img/D0010.f1b874fb.svg";